import { render, staticRenderFns } from "./task-users.vue?vue&type=template&id=20a73700"
import script from "./task-users.vue?vue&type=script&lang=js"
export * from "./task-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports